<template>
  <div class="breadcrumbs">
    <div class="container">
      <ul class="breadcrumbs__container">
        <li>
          <router-link :to="{ name: 'home' }">
            <span>Главная</span>
            <pre> / </pre>
          </router-link>
        </li>
        <li v-for="(link, i) in links" :key="i">
          <router-link :to="link.route" v-if="link.route">
            <span>{{ link.title }}</span>
            <pre> / </pre>
          </router-link>
          <span v-else>{{ link.title }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "BreadcrumbsComponent",
  props: {
    links: Array,
  },
};
</script>

<style lang="stylus">
.breadcrumbs {
  display flex
  padding 0 30px
  justify-content center
  align-items center
  &__button {
    margin-right 16px
  }

  &__container {
    display flex
    align-items baseline
    overflow-x auto
    &::-webkit-scrollbar {
      width: 0;
    }
    +below(860px) {
      align-items center
    }

    li {
      flex-shrink 0
      display flex
      align-items center

      a {
        font-weight: 700;
        font-size: 0.85em
        line-height: 114%
        color: var(--main-color-75)
        display: flex;
        align-items: center;
        transition var(--transition)
        +below(860px) {
          padding 2px 0
          //font-size: 1.125em
        }

        &:hover span {
          border-color inherit
        }

				span {
					transition var(--transition)
					border-bottom 1px solid transparent
				}

        .icon {
          width 12px
          height 12px
        }
      }

      > span {
        font-weight: 700;
        font-size: 0.85em
        line-height: 114%
        display: flex;
        align-items: center;
        color: var(--main-color);
        +below(860px) {
          //font-size: 1.125em
        }
      }
    }
  }

  .btn {
    flex-shrink 0
  }
}
</style>
